/* eslint-disable semi */

import DataFetcher from './DataFetcher'
import DataMapper from './DataMapper'

class BaseDataController {

  constructor() {
    this.cache = {}
  }

  cacheInMemory(options) {
    this.cache = { ...this.cache, [options.key]: options.value }
  }

  retrieveFromMemory(key) {
    return this.cache[key]
  }

  getUpdatedState() {
    return new Error(
      'Not Implemented: getUpdatedState must return JSON with state fragment.'
    )
  }

  getInitialState() {
    return new Error(
      'Not Implemented: getInitialState must return JSON with the correct state in full format.'
    )
  }
}
class DataController extends BaseDataController {

  constructor() {
    super()
    this.fetcher = new DataFetcher()
    this.mapper = new DataMapper()
  }

  /**
   * Submits the form data to the back-end
   * in the correct Rails format.
   * @returns Object
   */
  async submitState(form) {
    this.mapper.setData(form)
    const data = this.mapper.mappedData()
    const url = location.href
    const response = await this.fetcher.post(url, data)

    return response
  }

  /**
   * Fetches only fragment of the initial state needed for refreshing
   * specific parts of the form (e.g. required fields).
   * @returns Object
   */
  async getUpdatedState(transaction_type) {
    let response = this.retrieveFromMemory(transaction_type)

    if(!response) {
      const url = location.href + '/update'
      const data = { wpf_form: { transaction_type } }

      response = await this.fetcher.post(url, data)

      this.cacheInMemory({ key: transaction_type, value: response })
    }

    return response
  }

  /**
   * Fetches only fragment of the initial state needed for refreshing
   * billing address country of the form.
   * @returns Object
   */
  async getCountryUpdatedState(country, transaction_type) {
    const url = location.href + '/update'
    const data = { wpf_form: { billing_address_country: country } }
    const response = await this.fetcher.post(url, data)

    this.cacheInMemory({ key: transaction_type, value: response })

    return response
  }

  /**
   * Fetches ApplePay merchant session data
   * @returns Object
   */
  async applePayMerchantSession(validationURL) {

    const url = location.origin + '/en/mobile/payments/session'

    const data = {
      url: validationURL,
      unique_id: window.location.pathname.split('/').pop()
    }

    const response = await this.fetcher.post(url, data)

    return response
  }


  async invalidateCardToken(uniqueId, tokenId) {
    const url = location.href + '/invalidate_card_token'
    const transaction_type = 'credit_card'

    const data = {
      wpf_unique_id: uniqueId,
      token_id: tokenId,
      wpf_form: { transaction_type }
    }

    const response = await this.fetcher.post(url, data)

    this.cacheInMemory({ key: transaction_type, value: response })

    return response
  }

  async markCardDefault(uniqueId, tokenId) {
    const url = '/card_operations/' + tokenId
    const transaction_type = 'credit_card'

    const data = {
      wpf_unique_id: uniqueId,
      default_card: true
    }

    const response = await this.fetcher.put(url, data)

    if (!response.error) {
      this.cacheInMemory({ key: transaction_type, value: response.saved_cards })
    }

    return response
  }


  async cancelPayment() {
    const url = location.href + '/cancel'
    const response = await this.fetcher.get(url)

    if (response.url && response.directRedirection) {
      return this.redirect(response.url)
    }

    return response
  }

  /**
   * Fetches response for birthDate field to be rendered
   * @returns bool
   */
  async shouldRenderBirthDateField(cardNumber) {
    const url = location.href + '/birth_date_field'

    return await this.fetcher.post(url, { card_number: cardNumber })
  }


  /**
   * Fetches the data needed for the initial rendering of the form.
   * @returns Object
   */
  async getInitialState() {
    const url = location.href + '/show'

    let response = await this.fetcher.get(url)

    response = { ...response }

    if(response.paymentMethods) {
      this.cacheInitialData(response)
    }

    return response
  }

  cacheInitialData(response) {
    this.cacheInMemory({
      key: response.paymentMethods.default,
      value: {
        id: response.id,
        addresses: response.addresses,
        customerInfo: response.customerInfo,
        selectedPaymentMethods: response.selectedPaymentMethods
      }
    })
  }

  redirect(url) {
    window.location.replace(url)
  }
}

export default DataController
